import { StudentInfoModel } from './model';
import http from '/@/api/fetch';

const API = {
  getStudentInfo: '/student-web/v1/student/details',
  handleInviteLinks: '/auth-web/v1/user/handle-invite-links',
};

/**
 * 查询学员详情
 */
export const getStudentInfo = () => http.get<StudentInfoModel>(API.getStudentInfo);

/**
 * 处理邀请链接
 */
export const handleInviteLinks = (params: { inviteLinkId: string }) =>
  http.post(API.handleInviteLinks, params, { message: false });
